import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";

/** Add-attorney dialog shared by bond creation and retrieval flows. */
export default function BondAttorneyQuickAddDialog({
  open,
  onClose,
  onSubmit,
  attorney,
  setAttorney,
  disabled = false,
}) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>Add New Attorney</DialogTitle>
      <DialogContent>
        <TextField
          disabled={disabled}
          label="Attorney Name"
          name="name"
          value={attorney.name}
          onChange={(e) => setAttorney({ ...attorney, name: e.target.value })}
          fullWidth
          required
          margin="normal"
        />
        <TextField
          disabled={disabled}
          label="Phone"
          name="phone"
          value={attorney.phone}
          onChange={(e) => setAttorney({ ...attorney, phone: e.target.value })}
          fullWidth
          required
          margin="normal"
        />
        <TextField
          disabled={disabled}
          label="Email"
          name="email"
          type="email"
          value={attorney.email ?? ""}
          onChange={(e) => setAttorney({ ...attorney, email: e.target.value })}
          fullWidth
          required
          margin="normal"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={onSubmit} color="primary">
          Add Attorney
        </Button>
      </DialogActions>
    </Dialog>
  );
}
